import { displayToast } from "../modules/utils";
import FacebookPoster from "./facebook_poster";

export default class SocialMediaCreator {
  constructor(node) {
    this.element = node;
    this.targetTextElements = this.element.querySelectorAll(".js-social-example-text");
    this.targetMediaElements = this.element.querySelectorAll(".js-social-example-media");
    this.targetSwiper = this.element.querySelector(".js-social-example-target-swiper").swiper;
    this.downloadLink = this.element.querySelector(".js-social-download");
    this.postTrigger = this.element.querySelector(".js-social-post-trigger");

    this.activeTextContent = this.element.dataset.initialText;
    this.activeMediaContent = this.element.dataset.initialMediaUrl;
    this.mediaType = this.element.dataset.initialMediaType;

    this.initialize();
  }

  initialize() {
    this.setActiveSlide();
    this.handlePostTrigger();
    this.addSwiperEventListeners();
  }

  setActiveSlide() {
    const anchor = window.location.href.split("#").length > 1 ? window.location.href.split("#")[1] : null;

    if (anchor) {
      const tabs = this.element.querySelectorAll(".js-social-icons-swiper i.icon");

      tabs.forEach((tab, index) => {
        if (tab.className.includes(anchor)) {
          this.targetSwiper.slideTo(index, false, false);
        }
      });
    }

    this.selectedSocialMedia = this.targetSwiper.pagination.bullets[this.targetSwiper.activeIndex].dataset.name;
  }

  handlePostTrigger() {
    this.postTrigger.classList.toggle("d-none", this.selectedSocialMedia != "facebook");

    this.postTrigger.addEventListener("click", () => {
      const content = {
        text: this.activeTextContent,
        media: this.activeMediaContent,
        mediaType: this.mediaType,
      };

      switch (this.selectedSocialMedia) {
        case "facebook":
          const configContext = this.element.dataset;
          new FacebookPoster(configContext, content);
          break;
        case "instagram":
          // TODO: implement Instagram post API
          displayToast(this.element.dataset.errorMessage);
          break;
        default:
          displayToast(this.element.dataset.errorMessage);
          break;
      }
    });
  }

  addSwiperEventListeners() {
    const swiperElement = document.querySelector(".js-social-carousel");

    this.targetSwiper.on("slideChange", (e) => {
      this.selectedSocialMedia = this.targetSwiper.pagination.bullets[e.activeIndex].dataset.name;

      this.postTrigger.classList.toggle("d-none", this.selectedSocialMedia != "facebook");
    });

    if (!swiperElement) {
      return;
    }

    this.swiper = swiperElement.swiper;

    this.swiper.on("slideChange", (e) => {
      this.originalSlideContent = e.slides[e.activeIndex];
      this.mediaType = this.originalSlideContent.dataset.mediaType;
      this.updateDownloadLink(this.originalSlideContent.dataset.post);

      const contentType = this.originalSlideContent.dataset.type;

      if (contentType === "text") {
        this.targetTextElements.forEach((textEl) => {
          this.activeTextContent = this.originalSlideContent.innerText;
          textEl.innerText = this.originalSlideContent.innerText;
        });
      }
      if (contentType === "media") {
        this.targetMediaElements.forEach((mediaWrapper) => {
          mediaWrapper.innerHTML = this.originalSlideContent.innerHTML;

          // Since it can only be an image or a video, we check which one is present
          const url = mediaWrapper.querySelector("img") ? mediaWrapper.querySelector("img").src : mediaWrapper.querySelector("video").src;

          this.activeMediaContent = url;
        });
      }

      this.targetSwiper.update();
    });
  }

  updateDownloadLink(postId) {
    const oldLink = new URL(this.downloadLink, window.location.origin);
    oldLink.searchParams.set("post", postId);

    this.downloadLink.href = oldLink;
  }
}
